import { createFileRoute } from "@tanstack/react-router";
import { PillarPage, buildPillarHead } from "@/components/site/PillarPage";
import { PILLAR_BY_SLUG } from "@/lib/pillars";

const pillar = PILLAR_BY_SLUG["coaching-training"];

const faqs = [
  {
    q: "What does 1-on-1 coaching at KCN actually look like?",
    a: "Regular working sessions with a KCN coach focused on your numbers, your pipeline, your hiring, and your next milestone - not generic motivation. We pair coaching with the COLE Method™ so every conversation moves a real lever in your business.",
  },
  {
    q: "Who coaches the agents - Kristan or someone else?",
    a: "Kristan personally leads the Monthly Market Round Table and high-leverage strategy sessions. Day-to-day coaching is delivered by senior KCN operators trained inside the same playbook - agents who've built and led top-producing teams themselves.",
  },
  {
    q: "What kinds of opportunities come from being coached at KCN?",
    a: "Active KCN agents access consulting work, paid speaking, ownership opportunities, and affiliate business relationships across the national network. The pathway is: master the craft, run the playbook, and we route real opportunities to you.",
  },
  {
    q: "Is coaching included or an add-on?",
    a: "Coaching is core to the KCN model - it isn't a separate program you have to buy. The Monthly Market Round Table is where most agents first experience the depth of it; request an invitation to sit in.",
  },
];

export const Route = createFileRoute("/coaching-and-training")({
  head: () => buildPillarHead(pillar, faqs),
  component: () => (
    <PillarPage
      pillar={pillar}
      intro="Most real estate coaching is recycled motivation. KCN coaching is operator-level - built around your roster, your pipeline, your hires, and the next decision you actually have to make this week."
      sections={[
        {
          eyebrow: "How it starts",
          heading: "1-on-1 first. Then leverage.",
          body: "Every KCN journey opens with 1-on-1 coaching to set your foundation: numbers, business plan, and the gaps between where you are and where you've said you want to be. From there we move into Administrative Hiring Consulting and Team Recruitment - because growth without leverage is just more hours on your calendar.",
        },
        {
          eyebrow: "The training stack",
          heading: "Master every tool - then teach it.",
          body: "Coaching pairs with hands-on training on every system in the KCN stack - CRM, scripts, listing playbook, buyer process, marketing engine, and admin SOPs. The goal isn't to know about the tools; it's to be the operator other agents call when they get stuck.",
        },
        {
          eyebrow: "What it unlocks",
          heading: "Opportunities you can leverage.",
          bullets: [
            "Consulting opportunities inside the KCN network",
            "Speaking opportunities at KCN and industry events",
            "Ownership opportunities as expansion partners",
            "Affiliate business relationships across the network",
          ],
        },
      ]}
      benefits={{
        heading: "What coaching at KCN gives you.",
        items: [
          "CEO-level mentorship from a 40-year operator",
          "1-on-1 coaching tied to your real numbers",
          "Administrative hiring consulting",
          "Team recruitment support",
          "Documented training on every KCN tool",
          "A pathway from agent to team leader to owner",
        ],
      }}
      faqs={faqs}
    />
  ),
});
